import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { ScanPointService } from "../../services/scanpoint.service";
import { UpdateHallPassReasonRequest } from "../../services/UpdateHallPassReasonRequest";

@Component({
	selector: "app-edit-hall-pass-reason",
	templateUrl: "./edit-hall-pass-reason.component.html",
	styleUrls: ["./edit-hall-pass-reason.component.css"],
})
export class EditHallPassReasonComponent implements OnInit {
	constructor(public ref: DynamicDialogRef, private dialogConfig: DynamicDialogConfig, private scanPointService: ScanPointService) {}

	ngOnInit(): void {
		//Get data from parent
		this.user = this.dialogConfig.data.User;
		this.SelectedFacilityID = this.dialogConfig.data.FacilityID;

		this.UserType = this.user.UserLevelID == 1 ? "District User" : "School User";

		//Load data for selected Hall Pass Reason
		this.loadHallpassReason(this.dialogConfig.data.SelectedReason.ReasonID);
	}

	/////////////////////////
	// Data
	/////////////////////////
	user: any;
	UserType: any;
	SelectedFacilityID: any = 0;

	SelectedReasonData: any = null;

	//Form data
	PassReasonCode: string = "";
	PassReasonDesc: string = "";
	DefaultPassDur: number = 0;
	IsQuickPass: boolean = true;
	IsGroupAssign: boolean = true;
	IsAssignFromClass: boolean = true;
	IsDistrictLevel: boolean = false;
	UseClassAttnExcu: boolean = false;

	DefinedByType: any = "";
	//Security

	/////////////////////////

	/////////////////////////
	// Load Data
	/////////////////////////
	loadHallpassReason(reasonID) {
		var result = this.scanPointService.loadHallpassReason("", reasonID);
		result.subscribe(
			(response) => {
				this.SelectedReasonData = response[0];

				this.PassReasonCode = this.SelectedReasonData.HallpassReasonCD;
				this.PassReasonDesc = this.SelectedReasonData.HallpassReasonDesc;
				this.DefaultPassDur = this.SelectedReasonData.DefaultDurationMinutes;
				this.IsQuickPass = this.SelectedReasonData.IsQuick == 1 ? true : false;
				this.IsGroupAssign = this.SelectedReasonData.IsGroupAssignable == 1 ? true : false;
				this.IsAssignFromClass = this.SelectedReasonData.IsEDCRAssignable == 1 ? true : false;
				this.IsDistrictLevel = this.SelectedReasonData.FacilityID == 0 ? true : false;
				this.UseClassAttnExcu = this.SelectedReasonData.IsClassAttendanceExcuse == 1 ? true : false;

				this.DefinedByType = this.SelectedReasonData.DefinedByDesc;
			},
			(error) => {}
		);
	}
	/////////////////////////

	/////////////////////////
	// Buttons
	/////////////////////////
	onUpdate() {
		let parms: UpdateHallPassReasonRequest = {
			ApplicationItemID: "",
			HallpassReasonID: this.SelectedReasonData.HallpassReasonID,
			PassReasonCode: this.PassReasonCode,
			PassReasonDesc: this.PassReasonDesc,
			DefaultPassDur: this.DefaultPassDur,
			IsQuickPass: this.BoolToInt(this.IsQuickPass),
			IsGroupAssign: this.BoolToInt(this.IsGroupAssign),
			IsAssignFromClass: this.BoolToInt(this.IsAssignFromClass),
			IsDistrictLevel: this.BoolToInt(this.IsDistrictLevel),
			UseClassAttnExcu: this.BoolToInt(this.UseClassAttnExcu),
			DefinedBy: this.user.UserLevelID,
			FacilityID: this.SelectedFacilityID,
		};

		var result = this.scanPointService.UpdateHallPassReason(parms);
		result.subscribe(
			(response) => {
				this.ref.close(1);
			},
			(error) => {}
		);
	}
	onCancel() {
		this.ref.close(0);
	}
	/////////////////////////

	/////////////////////////
	// Helpers
	/////////////////////////
	GetTypeColor(val) {
		if (val == "System") {
			return "#0000FF";
		} else if (val == "District User") {
			return "#00bb19";
		} else if (val == "School User") {
			return "#a80000";
		} else {
			return "#0000FF";
		}
	}

	BoolToInt(val) {
		return val ? 1 : 0;
	}

	DisablePassCode() {
		//Defined by System
		if (this.SelectedReasonData.DefinedByID == 1) {
			return true;
		}
		//District Level but not District User
		if (this.SelectedReasonData.DefinedByID == 4 && this.user.UserLevelID != 1) {
			return true;
		}

		return false;
	}

	DisablePassDesc() {
		//Defined by System
		if (this.SelectedReasonData.DefinedByID == 1) {
			return true;
		}
		//District Level but not District User
		if (this.SelectedReasonData.DefinedByID == 4 && this.user.UserLevelID != 1) {
			return true;
		}

		return false;
	}

	DisableDuration() {
		//Defined by System
		// if(this.SelectedReasonData.DefinedByID == 1){
		//   return true;
		// }
		//District Level but not District User
		// if(this.SelectedReasonData.DefinedByID == 4 && this.user.UserLevelID != 1){
		//   return true;
		// }

		return false;
	}

	DisableQuickPass() {
		//Defined by System
		if (this.SelectedReasonData.DefinedByID == 1) {
			return true;
		}
		//District Level but not District User
		if (this.SelectedReasonData.DefinedByID == 4 && this.user.UserLevelID != 1) {
			return true;
		}

		return false;
	}

	DisableGroupAssign() {
		//Defined by System
		if (this.SelectedReasonData.DefinedByID == 1) {
			return true;
		}
		//District Level but not District User
		if (this.SelectedReasonData.DefinedByID == 4 && this.user.UserLevelID != 1) {
			return true;
		}

		return false;
	}

	DisableClassAssign() {
		//Defined by System
		if (this.SelectedReasonData.DefinedByID == 1) {
			return true;
		}
		//District Level but not District User
		if (this.SelectedReasonData.DefinedByID == 4 && this.user.UserLevelID != 1) {
			return true;
		}

		return false;
	}

	DisableDistLevel() {
		// //Defined by System
		// if(this.SelectedReasonData.DefinedByID == 1){
		//   return true;
		// }
		// //District Level
		// if(this.SelectedReasonData.DefinedByID == 4){
		//   return true;
		// }

		return true;

		// return false;
	}

	DisableUseClassAttn() {
		//Defined by System
		if (this.SelectedReasonData.DefinedByID == 1) {
			return true;
		}
		//District Level but not District User
		if (this.SelectedReasonData.DefinedByID == 4 && this.user.UserLevelID != 1) {
			return true;
		}

		return false;
	}

	/////////////////////////
}
